var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('searcher'),_c('div',{staticClass:"clear"}),_c('claims'),_c('div',{staticClass:"clear"}),_c('profiles'),_c('div',{staticClass:"clear"}),_c('newsletter'),_c('div',{staticClass:"clear"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }